// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1egGo","info":"PatientInfo_info__1w-9j"};